import React from 'react';
import { caseStudies } from '../../data/portfolioData';

const ArrowURIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" width="12" height="12" aria-hidden="true">
    <path d="M5 11L11 5M11 5H6.5M11 5v4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const GithubIcon = () => (
  <svg viewBox="0 0 16 16" fill="currentColor" width="12" height="12" aria-hidden="true">
    <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0016 8c0-4.42-3.58-8-8-8z" />
  </svg>
);

const LABEL_CONFIG = {
  'case-study': { cls: 'label label-case', text: 'Case Study' },
  arch: { cls: 'label label-arch', text: 'Backend Architecture' },
  fullstack: { cls: 'label label-arch', text: 'Backend Architecture' },
  ai: { cls: 'label label-ai', text: 'AI / ML' },
  oss: { cls: 'label label-oss', text: 'Open Source' },
};

function CaseLabel({ kind }) {
  const c = LABEL_CONFIG[kind] || { cls: 'label label-case', text: kind };
  return <span className={c.cls}>{c.text}</span>;
}

export default function CaseStudies() {
  return (
    <section className="section" id="case-studies">
      <div className="container">
        <div className="section-head reveal">
          <div>
            <div className="section-tag">Engineering Case Studies</div>
            <h2>Architecture-first systems built to production standards.</h2>
          </div>
          <p className="section-desc">
            Backend-heavy projects demonstrating system design, data modeling and API architecture depth.
          </p>
        </div>

        <div className="case-studies">
          {caseStudies.map(c => (
            <article key={c.name} className="case reveal">
              <div className="case-visual">
                {c.screenshot && (
                  <img
                    src={c.screenshot}
                    alt={`${c.name} screenshot`}
                    loading="lazy"
                    style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }}
                  />
                )}
              </div>

              <div className="project-labels">
                {c.labels.map(l => <CaseLabel key={l} kind={l} />)}
              </div>

              <div>
                <h3>{c.name}</h3>
                <p className="case-tagline" style={{ marginTop: '8px' }}>{c.tagline}</p>
              </div>

              {c.highlights && c.highlights.length > 0 && (
                <ul className="case-highlights">
                  {c.highlights.map((h, i) => <li key={i}>{h}</li>)}
                </ul>
              )}

              {c.demoCredentials && (
                <div className="demo-credentials">
                  <span className="demo-credentials-label">Demo access</span>
                  {c.demoCredentials.user && (
                    <span className="demo-credentials-pair">
                      <span className="demo-credentials-key">user</span>
                      <span className="demo-credentials-val">{c.demoCredentials.user}</span>
                    </span>
                  )}
                  {c.demoCredentials.email && (
                    <span className="demo-credentials-pair">
                      <span className="demo-credentials-key">email</span>
                      <span className="demo-credentials-val">{c.demoCredentials.email}</span>
                    </span>
                  )}
                  <span className="demo-credentials-pair">
                    <span className="demo-credentials-key">pass</span>
                    <span className="demo-credentials-val">{c.demoCredentials.password}</span>
                  </span>
                </div>
              )}

              <div className="case-bottom">
                <div className="project-stack">
                  {c.stack.map(s => <span key={s} className="chip">{s}</span>)}
                </div>
                <div className="project-actions">
                  {c.links.map((l, i) => (
                    <a
                      key={i}
                      className="project-link"
                      href={l.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {l.kind === 'github' && <GithubIcon />}
                      {l.label}
                      {l.kind !== 'github' && <ArrowURIcon />}
                    </a>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
